import { render, staticRenderFns } from "./BatchCreateTest.vue?vue&type=template&id=b679b4cc&scoped=true"
import script from "./BatchCreateTest.vue?vue&type=script&lang=js"
export * from "./BatchCreateTest.vue?vue&type=script&lang=js"
import style0 from "./BatchCreateTest.vue?vue&type=style&index=0&id=b679b4cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b679b4cc",
  null
  
)

export default component.exports